<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useHead } from '@unhead/vue'
import VoxHeroCarousel from '../components/VoxHeroCarousel.vue'
import VoxWaveform3D from '../components/VoxWaveform3D.vue'
import VoxSection from '../components/VoxSection.vue'
import VoxBrandHeading from '../components/VoxBrandHeading.vue'
import VoxPartnerGrid from '../components/VoxPartnerGrid.vue'
import VoxCTA from '../components/VoxCTA.vue'

useHead({
  title: 'Voxbet',
  meta: [
    { name: 'description', content: 'Voxbet provides cutting-edge voice and text betting technology for modern sportsbooks.' }
  ]
})

const partners = [
  { name: 'William Hill', logo: new URL('../assets/partners/williamhill.svg', import.meta.url).href },
  { name: 'Paddy Power', logo: new URL('../assets/partners/paddypower.svg', import.meta.url).href },
  { name: 'PMU', logo: new URL('../assets/partners/pmu.svg', import.meta.url).href },
  { name: 'TOTE', logo: new URL('../assets/partners/tote.svg', import.meta.url).href },
]

const featuredImage = new URL('../assets/images/solutions/speak-type-bet-1.webp', import.meta.url).href
const ctaBgImage = new URL('../assets/images/cta/football-tv.webp', import.meta.url).href

// Reveal on scroll logic
let observer: IntersectionObserver | null = null

onMounted(() => {
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active')
      }
    })
  }, { threshold: 0.1 })

  document.querySelectorAll('.reveal-on-scroll').forEach(el => {
    observer?.observe(el)
  })
})

onUnmounted(() => {
  observer?.disconnect()
})
</script>

<template>
  <div class="home-view">
    <VoxWaveform3D />
    <VoxHeroCarousel />

    <!-- Featured Section -->
    <VoxSection padding="120px 0">
      <div class="featured-grid">
        <div class="featured-graphic glass-card neon-glow reveal-on-scroll reveal-left">
          <img :src="featuredImage" alt="Speak Type Bet" class="img-fluid" />
          <div class="speech-bubble">
            <span class="speech-text">"10 dollar parlay pistons 76ers bulls magic and jazz"</span>
          </div>
        </div>

        <div class="featured-text reveal-on-scroll reveal-right">
          <VoxBrandHeading 
            label="Intelligence Redefined"
            title="Speak. Type. Bet"
          />
          <p class="lead">52% of under 35’s engage digitally with voice every day already.</p>
          <p>Sportsbooks can be complicated. Allowing customers to interact with your sportsbook as they do with other e-commerce sites will give you an edge.</p>
          <div class="mt-12 featured-btn-wrapper">
            <RouterLink to="/solutions" class="btn btn-outline">Learn More</RouterLink>
          </div>
        </div>
      </div>
    </VoxSection>

    <!-- Partners Section -->
    <VoxSection padding="80px 0">
      <VoxPartnerGrid 
        title="Trusted by Global Leaders"
        :partners="partners"
        class="reveal-on-scroll reveal-up"
      />
    </VoxSection>

    <!-- CTA Section -->
    <VoxSection class="cta-section" padding="150px 0">
      <VoxCTA 
        title="Ready to talk?"
        subtitle="Let's talk about tomorrow."
        buttonText="Get in touch"
        buttonLink="/get-in-touch"
        :backgroundImage="ctaBgImage"
        class="reveal-on-scroll reveal-up"
      />
    </VoxSection>
  </div>
</template>

<style scoped>
/* HomeView Specific styles are already in index.css but keeping local overrides if needed */
</style>
